import { render, staticRenderFns } from "./CardNewsSmall.vue?vue&type=template&id=636b6072&scoped=true&"
import script from "./CardNewsSmall.vue?vue&type=script&lang=js&"
export * from "./CardNewsSmall.vue?vue&type=script&lang=js&"
import style0 from "./CardNewsSmall.vue?vue&type=style&index=0&id=636b6072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b6072",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VCol,VHover,VRow})
